import React from 'react';
import styles from './styles.module.pcss';
import { useReactiveVar } from '@apollo/client';
import { currentUserVar } from '@/graphql/operations/user';
import { getLogoUrlForOrganisation } from '@/utils/getLogoUrlForOrganisation';

type Props = {
  children: React.ReactNode;
};

const SendGridTemplatePreview: React.FC<Props> = ({ children }) => {
  const currentUser = useReactiveVar(currentUserVar);

  return (
    <div className={styles.root}>
      <div className={styles.imgDiv}>
        <img
          className={styles.logo}
          alt="customer-logo"
          data-proportionally-constrained="true"
          data-responsive="true"
          src={getLogoUrlForOrganisation(currentUser.organization.name)}
        />
      </div>
      <div className={styles.childrenDiv}>{children}</div>
      <div>
        <div className={styles.container}>
          <span className={styles.text}>Need more help figuring things out? Our support team is here to help!</span>
        </div>
        <div className={styles.container}></div>
        <div className={styles.container}>
          <span className={styles.text}>Please email us at&nbsp;</span>
          <span>
            <a href="mailto:contact@aryaworks.com" className={styles.text}>
              contact@aryaworks.com
            </a>
          </span>
        </div>
      </div>
    </div>
  );
};

export default SendGridTemplatePreview;
